import type { Nilable } from './type-guards';

/**
 * TODO: there's two disparate functions here, one for getting the extension by file type and one for getting the extension by file name.
 * This should be consolidated into one getExtension function that attempts both methods, falling back to the file name if the file type doesn't have a known extension.
 * Otherwise, return .bin.
 */

const FILE_TYPE_TO_EXTENSION_MAP = new Map([
  ['application/font-woff', 'woff'],
  ['application/font-woff2', 'woff2'],
  ['font/woff', 'woff'],
  ['font/woff2', 'woff2'],
]);

export const getExtensionByFileType = ({ type }: File): string | undefined =>
  FILE_TYPE_TO_EXTENSION_MAP.get(type) ?? type.split('/').pop();

export const BIN_EXTENSION = 'bin';

const getExtensionByFileName = (file: File): Nilable<string> => {
  const { name } = file;
  const splitName = name.split('.');

  if (splitName.length <= 1) {
    return null;
  }

  return splitName[splitName.length - 1];
};

export const getExtension = (file: File): Nilable<string> => {
  switch (file.type) {
    case 'font/woff':
      return 'woff';
    case 'font/woff2':
      return 'woff2';
    case 'font/ttf':
      return 'ttf';
    case 'font/otf':
      return 'otf';
    default:
      return getExtensionByFileName(file);
  }
};
